import { View } from 'react-native';
import { DYNAMIC_MODAL_VIEWS } from 'src/store/_models/dynamic-modal-layer/dynamicModalLayer.constants';
import { brand, neutrals } from 'src/theme/colors';
import { Icon } from '../icon/Icon';
import { ICON_NAMES } from '../icon/icon.helper';
import { useStore } from 'src/contexts/StoreContext';
import { style } from './PrivacyPolicyCtaDesktop.style';
import { TestIDs } from 'src/constants/testIDs.constants';
import Button from '../buttons/button/Button';
import { FocusGroups } from '../focus-provider/FocusProvider.constants';
import { BUTTON_TEXT_POSITIONS } from '../buttons/button/Button.types.constants';

export const PrivacyPolicyCtaDesktop = () => {
  const { dynamicModal, i18n } = useStore();

  return (
    <Button
      testID={TestIDs.PRIVACY_POLICY_CTA}
      style={style.button}
      onPress={async () => {
        dynamicModal && dynamicModal.openModal({ dynamicModalView: DYNAMIC_MODAL_VIEWS.PrivacyPolicy });
      }}
      accessible={true}
      accessibilityLabel={i18n.t('modal-privacy-policy:privacy-policy-info')}
      accessibilityRole="button"
      innerStyle={style.buttonInner}
      text={i18n.t('modal-privacy-policy:privacy-policy-info')}
      textStyle={style.text}
      textHoverStyle={style.textHover}
      focusId={TestIDs.PRIVACY_POLICY_CTA}
      focusOrder={0}
      focusGroup={FocusGroups.BOTTOM_BAR}
      textPosition={BUTTON_TEXT_POSITIONS.RIGHT}
      focusStyle={style.buttonFocus}
    >
      {({ hovered }) => (
        <View style={style.icon}>
          <Icon
            name={ICON_NAMES.Info}
            color={hovered ? brand.main.variations['darkerWater-1'] : neutrals.neutralGrays.ash}
          />
        </View>
      )}
    </Button>
  );
};
